import React from 'react';
import '../assets/styles/modal.css';

const BankVerificationSuccessModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                <button className="modal-close" onClick={onClose}>&times;</button>

                {/* Icono de éxito */}
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <div style={{
                        width: '80px',
                        height: '80px',
                        margin: '0 auto 15px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #4caf50 0%, #45a049 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 20px rgba(76, 175, 80, 0.3)'
                    }}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </div>
                    <h2 style={{ color: '#4caf50', marginBottom: '10px', fontSize: '1.5rem' }}>
                        ¡Solicitud Enviada Exitosamente!
                    </h2>
                </div>

                {/* Información del proceso */}
                <div style={{
                    background: 'rgba(76, 175, 80, 0.1)',
                    border: '1px solid rgba(76, 175, 80, 0.3)',
                    borderRadius: '8px',
                    padding: '20px',
                    marginBottom: '20px'
                }}>
                    <h3 style={{ fontSize: '1rem', marginBottom: '15px', color: '#2e7d32' }}>
                        📋 Próximos Pasos
                    </h3>
                    <ol style={{ paddingLeft: '20px', lineHeight: '1.8', fontSize: '0.9rem', color: '#333' }}>
                        <li style={{ marginBottom: '10px' }}>
                            <strong>Revisión de datos:</strong> Nuestro equipo verificará la información bancaria proporcionada.
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                            <strong>Depósito de verificación:</strong> Recibirás un monto aleatorio entre <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>$10 y $100 CLP</span> en tu cuenta bancaria.
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                            <strong>Confirmación:</strong> Deberás ingresar el monto exacto recibido para completar la verificación.
                        </li>
                    </ol>
                </div>

                {/* Tiempo estimado */}
                <div style={{
                    background: 'rgba(33, 150, 243, 0.1)',
                    border: '1px solid rgba(33, 150, 243, 0.3)',
                    borderRadius: '8px',
                    padding: '15px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>24h</div>
                    <div>
                        <div style={{ fontSize: '0.85rem', color: '#1976d2', fontWeight: 'bold', marginBottom: '3px' }}>
                            Tiempo Estimado
                        </div>
                        <div style={{ fontSize: '0.9rem', color: '#333' }}>
                            El depósito puede tardar <strong>hasta 24 horas hábiles</strong>
                        </div>
                    </div>
                </div>

                {/* Recordatorio importante */}
                <div style={{
                    background: 'rgba(255, 152, 0, 0.1)',
                    border: '1px solid rgba(255, 152, 0, 0.3)',
                    borderRadius: '8px',
                    padding: '15px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px'
                }}>
                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', marginTop: '2px' }}>Tip</div>
                    <div>
                        <div style={{ fontSize: '0.85rem', color: '#e65100', fontWeight: 'bold', marginBottom: '5px' }}>
                            Importante
                        </div>
                        <ul style={{ paddingLeft: '18px', margin: 0, fontSize: '0.85rem', color: '#333', lineHeight: '1.6' }}>
                            <li>Revisa tu cuenta bancaria regularmente</li>
                            <li>El monto será un valor exacto (ej: $47, $82)</li>
                            <li>Tendrás 3 intentos para ingresar el monto correcto</li>
                            <li>Si tienes dudas, contacta a soporte</li>
                        </ul>
                    </div>
                </div>

                {/* Botón de cierre */}
                <button
                    onClick={onClose}
                    style={{
                        width: '100%',
                        padding: '12px',
                        background: 'linear-gradient(135deg, #4caf50 0%, #45a049 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                >
                    Entendido
                </button>
            </div>
        </div>
    );
};

export default BankVerificationSuccessModal;
